// Owner page: จัดการร้าน → รูปเมนู LINE. The designer itself lives in MenuDesigner (also used by the Console).
import { useShop } from '../app/boot.tsx';
import { useShopPaths } from '../app/nav.tsx';
import { Page } from '../ui/index.tsx';
import { MenuDesigner } from './MenuDesigner.tsx';

export function RichMenu() {
  const { api, shop } = useShop();
  const { go } = useShopPaths();
  return (
    <Page title="รูปเมนู LINE" back={() => go('/staff/manage')}>
      <MenuDesigner storeKey={`menu-art:${shop.slug}`} shopName={shop.name}
        upload={(b64, type, extras) => api.staff.richMenuImage(b64, type, extras)} />
    </Page>
  );
}
